import furComponent from './fur-component/store';
import furBlock from './fur-block/store';
import nav from './fur-nav/store';
import retrieval from './fur-retrieval/store';

export default {
  namespaced: true,
  modules: { furComponent, furBlock, nav, retrieval },
};
